function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1-28s{fill:#1b1464}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "8-fe0Group_14094",
  transform: "translate(.846)"
}, /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21987",
  d: "M411.77 379.64v5.225h5.225v-5.225h-5.225zm3.483 1.742v1.742h-1.742v-1.742z",
  className: "cls-1-28s",
  transform: "translate(-408.337 -376.157)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21988",
  d: "M381.971 351.558v-1.717h3.458V348.1h-5.2v5.175h1.742z",
  className: "cls-1-28s",
  transform: "translate(-380.23 -348.05)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21989",
  d: "M477.512 379.64h-1.742v1.742h3.483v1.742h1.742v-3.484h-3.483z",
  className: "cls-1-28s",
  transform: "translate(-465.129 -376.157)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21990",
  d: "M575.253 347.64h-3.483v1.742h3.483v3.483h1.742v-5.225z",
  className: "cls-1-28s",
  transform: "translate(-550.437 -347.64)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Rectangle_5062",
  d: "M0 0H1.742V1.742H0z",
  className: "cls-1-28s",
  transform: "translate(10.606 6.766)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21991",
  d: "M543.253 384.865h1.742v-5.225h-5.225v5.225h3.483zm-1.742-3.483h1.742v1.742h-1.742z",
  className: "cls-1-28s",
  transform: "translate(-521.921 -376.157)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Rectangle_5063",
  d: "M0 0H1.742V1.742H0z",
  className: "cls-1-28s",
  transform: "translate(14.159 8.458)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Rectangle_5064",
  d: "M0 0H1.742V1.742H0z",
  className: "cls-1-28s",
  transform: "translate(14.159 15.224)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Rectangle_5065",
  d: "M0 0H1.742V1.742H0z",
  className: "cls-1-28s",
  transform: "translate(10.606 16.916)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Rectangle_5066",
  d: "M0 0H1.742V1.742H0z",
  className: "cls-1-28s",
  transform: "translate(8.83 15.224)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21992",
  d: "M413.512 507.64h-1.742v5.225h5.225v-5.225h-3.483zm1.742 3.483h-1.742v-1.742h1.742z",
  className: "cls-1-28s",
  transform: "translate(-408.337 -490.924)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21993",
  d: "M479.253 523.64h-1.742v1.742h-1.741v1.742h5.225v-1.742h-1.742z",
  className: "cls-1-28s",
  transform: "translate(-465.129 -505.182)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21994",
  d: "M381.971 542.868v-3.458h-1.741v5.2h5.225v-1.742h-3.483z",
  className: "cls-1-28s",
  transform: "translate(-380.23 -519.236)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21995",
  d: "M544.995 512.865v-5.225h-5.225v5.225h5.225zm-3.483-1.742v-1.742h1.742v1.742z",
  className: "cls-1-28s",
  transform: "translate(-521.921 -490.924)"
}), /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21996",
  d: "M575.253 541.382v1.742h-3.483v1.742h5.225v-5.226h-1.742z",
  className: "cls-1-28s",
  transform: "translate(-550.437 -519.441)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "8-fe0Path_21997",
  fill: "#c92941",
  d: "M398.937 451.64a1.775 1.775 0 0 0-1.533.871h-21.639a1.775 1.775 0 0 0-1.533-.871 1.742 1.742 0 1 0 0 3.483 1.775 1.775 0 0 0 1.533-.871H397.4a1.775 1.775 0 0 0 1.533.871 1.742 1.742 0 1 0 0-3.483z",
  transform: "translate(-372.46 -440.67)"
});

var SvgHPayment = function SvgHPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "8-fe0Group_14224",
    width: 28.249,
    height: 25.424,
    viewBox: "0 0 28.249 25.424",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-payment.a2f13c46.svg";
export { ForwardRef as ReactComponent };